import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VRow,{staticClass:"my-0 py-12"},[(_vm.isEditorial && _vm.isBroken)?_c(VCol,{staticClass:"my-12 py-12 text-center"},[_vm._v(" Cannot generate preview of this video (ID: "+_vm._s(_vm.videoId)+") "),_c('br'),_vm._v(" Please contact support ")]):_c(VCol,{staticClass:"my-12 py-12 text-center"},[_c(VProgressCircular,{staticClass:"mr-2",attrs:{"indeterminate":"","color":"primary"}}),_vm._v(" Generating video preview... ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }